module.exports = __webpack_public_path__ + "img/pc-invisible.b832583d.svg";